@if (claimsHeading) {
  <p margin-bottom-small-x [innerHTML]="claimsHeading"></p>
}

@if (orderedClaims) {
  <ol class="claims" no-margin padding-left-large>
    <ng-template [ngTemplateOutlet]="claims"></ng-template>
  </ol>
} @else {
  <ul class="claims" no-margin padding-left>
    <ng-template [ngTemplateOutlet]="claims"></ng-template>
  </ul>
}

<ng-template #claims>
  @for (claim of $any(claimsList); track trackByValue($index, claim)) {
    <li [innerHTML]="claim"></li>
  }
</ng-template>

@if (textUnderClaims) {
  <rt-message margin-tb variant="context-warning">
    <p no-margin [innerHTML]="textUnderClaims"></p>
  </rt-message>
}
